import {useMemo} from 'react';

/**
 * Custom hook to organize saved highlights by segment index
 * @param {Array} savedHighlights - Array of highlight objects
 * @returns {Map} Map of segment index to array of highlight ranges
 */
export function useHighlightsBySegment(savedHighlights) {
    return useMemo(() => {
        const map = new Map();
        for (const h of savedHighlights || []) {
            if (!h || !h.start || !h.end) continue;

            const sI = Number(h.start.segmentIndex);
            const eI = Number(h.end.segmentIndex);
            const sO = Number(h.start.segmentOffset ?? 0);
            const eO = Number(h.end.segmentOffset ?? 0);

            if (Number.isNaN(sI) || Number.isNaN(eI)) continue;

            const isReversed = sI > eI || (sI === eI && sO > eO);
            const startI = isReversed ? eI : sI;
            const endI = isReversed ? sI : eI;
            const startO = isReversed ? eO : sO;
            const endO = isReversed ? sO : eO;

            for (let i = startI; i <= endI; i++) {
                if (!map.has(i)) map.set(i, []);
                map.get(i).push({
                    id: h.id || `${i}-${startI}:${startO}-${endO}`,
                    type: h.type || 'saved',
                    startIndex: startI,
                    endIndex: endI,
                    startOffset: startO,
                    endOffset: endO,
                    labelText: h.labelText,
                });
            }
        }
        return map;
    }, [savedHighlights]);
}
